import { ICursorElements, IState } from '@/store/types/search.types';
import { ISupportUser, TFavorite } from '@/features/dashboard-users/store/support-user.model';
import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';
import {
  IDeletePasskeyAction,
  IDeletePasskeyFailAction,
  IDeletePasskeySuccessAction,
} from '@/features/2fa/store/types/auth2Fa.types';

export enum SupportUserActionTypes {
  SEARCH_SUPPORT_USERS = 'SUPPORT_USER.SEARCH_SUPPORT_USERS',
  SEARCH_SUPPORT_USERS_SUCCESS = 'SUPPORT_USER.SEARCH_SUPPORT_USERS_SUCCESS',
  SEARCH_SUPPORT_USERS_FAIL = 'SUPPORT_USER.SEARCH_SUPPORT_USERS_FAIL',

  SEARCH_SUSPENDED_SUPPORT_USERS = 'SUPPORT_USER.SEARCH_SUSPENDED_SUPPORT_USERS',
  SEARCH_SUSPENDED_SUPPORT_USERS_SUCCESS = 'SUPPORT_USER.SEARCH_SUSPENDED_SUPPORT_USERS_SUCCESS',
  SEARCH_SUSPENDED_SUPPORT_USERS_FAIL = 'SUPPORT_USER.SEARCH_SUSPENDED_SUPPORT_USERS_FAIL',

  ADD_SUPPORT_USER = 'SUPPORT_USER.ADD_SUPPORT_USER',
  ADD_SUPPORT_USER_SUCCESS = 'SUPPORT_USER.ADD_SUPPORT_USER_SUCCESS',
  ADD_SUPPORT_USER_FAIL = 'SUPPORT_USER.ADD_SUPPORT_USER_FAIL',

  UPDATE_SUPPORT_USER = 'SUPPORT_USER.UPDATE_SUPPORT_USER',
  UPDATE_SUPPORT_USER_SUCCESS = 'SUPPORT_USER.UPDATE_SUPPORT_USER_SUCCESS',
  UPDATE_SUPPORT_USER_FAIL = 'SUPPORT_USER.UPDATE_SUPPORT_USER_FAIL',

  UPDATE_CURRENT_SUPPORT_USER_METADATA = 'SUPPORT_USER.UPDATE_CURRENT_SUPPORT_USER_METADATA',
  UPDATE_CURRENT_SUPPORT_USER_METADATA_SUCCESS = 'SUPPORT_USER.UPDATE_CURRENT_SUPPORT_USER__METADATA_SUCCESS',
  UPDATE_CURRENT_SUPPORT_USER_METADATA_FAIL = 'SUPPORT_USER.UPDATE_CURRENT_SUPPORT_USER__METADATA_FAIL',

  REMOVE_SUPPORT_USER = 'SUPPORT_USER.REMOVE_SUPPORT_USER',
  REMOVE_SUPPORT_USER_SUCCESS = 'SUPPORT_USER.REMOVE_SUPPORT_USER_SUCCESS',
  REMOVE_SUPPORT_USER_FAIL = 'SUPPORT_USER.REMOVE_SUPPORT_USER_FAIL',

  SET_CURRENT_SUPPORT_USER = 'SUPPORT_USER.SET_CURRENT_SUPPORT_USER',

  UNBLOCK_SUPPORT_USER = 'SUPPORT_USER.UNBLOCK_SUPPORT_USER',
  UNBLOCK_SUPPORT_USER_SUCCESS = 'SUPPORT_USER.UNBLOCK_SUPPORT_USER_SUCCESS',
  UNBLOCK_SUPPORT_USER_FAIL = 'SUPPORT_USER.UNBLOCK_SUPPORT_USER_FAIL',

  SUSPEND_SUPPORT_USER = 'SUPPORT_USER.SUSPEND_SUPPORT_USER',
  SUSPEND_SUPPORT_USER_SUCCESS = 'SUPPORT_USER.SUSPEND_SUPPORT_USER_SUCCESS',
  SUSPEND_SUPPORT_USER_FAIL = 'SUPPORT_USER.SUSPEND_SUPPORT_USER_FAIL',

  RESTORE_SUPPORT_USER_ACCESS = 'SUPPORT_USER.RESTORE_SUPPORT_USER_ACCESS',
  RESTORE_SUPPORT_USER_ACCESS_SUCCESS = 'SUPPORT_USER.RESTORE_SUPPORT_USER_ACCESS_SUCCESS',
  RESTORE_SUPPORT_USER_ACCESS_FAIL = 'SUPPORT_USER.RESTORE_SUPPORT_USER_ACCESS_FAIL',

  SET_REVIEW = 'SET_REVIEW',
  SET_REVIEW_SUCCESS = 'SUPPORT_USER.SET_REVIEW_SUCCESS',
  SET_REVIEW_FAIL = 'SUPPORT_USER.SET_REVIEW_FAIL',

  CHANGE_PASSWORD = 'SUPPORT_USER.CHANGE_PASSWORD',
  CHANGE_PASSWORD_SUCCESS = 'SUPPORT_USER.CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAIL = 'SUPPORT_USER.CHANGE_PASSWORD_FAIL',

  SHOULD_CHANGE_PASSWORD = 'SUPPORT_USER.SHOULD_CHANGE_PASSWORD',

  UPDATE_EXPIRATION = 'UPDATE_EXPIRATION',
  UPDATE_EXPIRATION_FAIL = 'UPDATE_EXPIRATION_FAIL',
  UPDATE_EXPIRATION_SUCCESS = 'UPDATE_EXPIRATION_SUCCESS',
}

export interface ISearchSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SEARCH_SUPPORT_USERS;
}

export interface ISearchSupportUserSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SEARCH_SUPPORT_USERS_SUCCESS;
  supportUsers: ICursorElements<ISupportUser>;
}

export interface ISearchSupportUserFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SEARCH_SUSPENDED_SUPPORT_USERS_FAIL;
  error: TAppError;
}

export interface ISearchSuspendedSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SEARCH_SUSPENDED_SUPPORT_USERS;
}

export interface ISearchSuspendedSupportUserSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SEARCH_SUSPENDED_SUPPORT_USERS_SUCCESS;
  supportUsers: ICursorElements<ISupportUser>;
}

export interface ISearchSuspendedSupportUserFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SEARCH_SUPPORT_USERS_FAIL;
  error: TAppError;
}

export interface ISetCurrentSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SET_CURRENT_SUPPORT_USER;
  user: ISupportUser;
}

export interface IAddSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.ADD_SUPPORT_USER;
}

export interface IAddSupportUserSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.ADD_SUPPORT_USER_SUCCESS;
  supportUser: ISupportUser;
}

export interface IAddSupportUserFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.ADD_SUPPORT_USER_FAIL;
  error: TAppError;
}

export interface IUpdateSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_SUPPORT_USER;
  id: string;
}

export interface IUpdateSupportUserSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_SUPPORT_USER_SUCCESS;
  supportUser: ISupportUser;
}

export interface IUpdateSupportUserFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_SUPPORT_USER_FAIL;
  id: string;
  error: TAppError;
}

export interface IUpdateSupportUserMetadataAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_CURRENT_SUPPORT_USER_METADATA;
  id: string;
  favoriteId: number;
}

export interface IUpdateSupportUserMetadataSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_CURRENT_SUPPORT_USER_METADATA_SUCCESS;
  id: string;
  favorites: TFavorite[];
}

export interface IUpdateSupportUserMetadataFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_CURRENT_SUPPORT_USER_METADATA_FAIL;
  id: string;
  error: TAppError;
}

export interface IRemoveSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.REMOVE_SUPPORT_USER;
}

export interface IRemoveSupportUserSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.REMOVE_SUPPORT_USER_SUCCESS;
  supportUserId: string;
  isSuspended?: boolean;
}

export interface IRemoveSupportUserFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.REMOVE_SUPPORT_USER_FAIL;
  error: TAppError;
}

export interface ISuspendSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SUSPEND_SUPPORT_USER;
  id: string;
}

export interface ISuspendSupportUserSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SUSPEND_SUPPORT_USER_SUCCESS;
  supportUser: ISupportUser;
}

export interface ISuspendSupportUserFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SUSPEND_SUPPORT_USER_FAIL;
  id: string;
  error: TAppError;
}

export interface IRestoreSupportUserAccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.RESTORE_SUPPORT_USER_ACCESS;
  id: string;
}

export interface IRestoreSupportUserAccessSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.RESTORE_SUPPORT_USER_ACCESS_SUCCESS;
  supportUser: ISupportUser;
}

export interface IRestoreSupportUserAccessFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.RESTORE_SUPPORT_USER_ACCESS_FAIL;
  id: string;
  error: TAppError;
}

export interface IUnblockSupportUserAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UNBLOCK_SUPPORT_USER;
  id: string;
}

export interface IUnblockSupportUserSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UNBLOCK_SUPPORT_USER_SUCCESS;
  supportUser: ISupportUser;
}

export interface IUnblockSupportUserFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UNBLOCK_SUPPORT_USER_FAIL;
  id: string;
  error: TAppError;
}

export interface IRolesSetReviewdAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SET_REVIEW;
  isReviewed: boolean;
}
export interface IRolesSetReviewdActionSuccess extends IBaseAction {
  type: typeof SupportUserActionTypes.SET_REVIEW_SUCCESS;
  isReviewed: boolean;
}

export interface IRolesSetReviewdActionFail extends IBaseAction {
  type: typeof SupportUserActionTypes.SET_REVIEW_FAIL;
  isReviewed: boolean;
  error: TAppError;
}

export interface IChangePasswordAction extends IBaseAction {
  type: typeof SupportUserActionTypes.CHANGE_PASSWORD;
}

export interface IChangePasswordSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.CHANGE_PASSWORD_SUCCESS;
  supportUser: ISupportUser;
}

export interface IChangePasswordFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.CHANGE_PASSWORD_FAIL;
  error: TAppError;
}

export interface IShouldChangePasswordAction extends IBaseAction {
  type: typeof SupportUserActionTypes.SHOULD_CHANGE_PASSWORD;
  shouldChangePassword: boolean;
}

export interface IUpdateAccessExpirationAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_EXPIRATION;
}
export interface IUpdateAccessExpirationFailAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_EXPIRATION_FAIL;
  error: TAppError;
}
export interface IUpdateAccessExpirationSuccessAction extends IBaseAction {
  type: typeof SupportUserActionTypes.UPDATE_EXPIRATION_SUCCESS;
}

export type TSupportUserAction =
  | ISearchSupportUserAction
  | ISearchSupportUserFailAction
  | ISearchSupportUserSuccessAction
  | IAddSupportUserAction
  | IAddSupportUserFailAction
  | IAddSupportUserSuccessAction
  | IUpdateSupportUserAction
  | IUpdateSupportUserFailAction
  | IUpdateSupportUserSuccessAction
  | IRemoveSupportUserAction
  | IRemoveSupportUserFailAction
  | IRemoveSupportUserSuccessAction
  | IUnblockSupportUserAction
  | IUnblockSupportUserSuccessAction
  | IUnblockSupportUserFailAction
  | IRolesSetReviewdAction
  | IRolesSetReviewdAction
  | IRolesSetReviewdActionSuccess
  | IRolesSetReviewdActionFail
  | IUpdateAccessExpirationAction
  | IUpdateAccessExpirationFailAction
  | IUpdateAccessExpirationSuccessAction
  | IDeletePasskeyAction
  | IDeletePasskeyFailAction
  | IDeletePasskeySuccessAction
  | ISuspendSupportUserAction
  | ISuspendSupportUserFailAction
  | ISuspendSupportUserSuccessAction
  | ISearchSuspendedSupportUserFailAction
  | ISearchSuspendedSupportUserAction
  | ISearchSuspendedSupportUserSuccessAction
  | IRestoreSupportUserAccessAction
  | IRestoreSupportUserAccessSuccessAction
  | IRestoreSupportUserAccessFailAction;

export interface ISupportUserState extends IBaseState {
  dashboardUsers: ICursorElements<IState<ISupportUser>>;
  suspendedDashboardUsers?: ICursorElements<IState<ISupportUser>>;
  create?: IState;
  remove?: IState;
  search?: IState;
  searchSuspendedDashboardUsers?: IState;
}
